const lang = {
    'hero-caption-1': '經濟部工業局補助',
    'hero-caption-2': ' ',
    'travel-title': '累積總里程數',
    'travel-description-1': '相當於繞地球 %{count} 圈',
    'travel-description-2': ' ',
    'saving-title': 'CO<sub>2</sub> 總排放量減少',
    'saving-description-1': '相當於每年 %{count} 棵樹的吸收量',
    'saving-description-2': ' ',
    'summary': '以上數據截至 %{year} 年 %{month} 月 %{day} 日，根據經濟部工業局補助之 %{scooters} 台已投入使用車輛里程數計算得出。',
};

export default lang;
